module.exports = __webpack_public_path__ + "img/health_thumbnail-600x450.4a9af370.jpg";